(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('PlannedShipment', PlannedShipment);

    PlannedShipment.$inject = ['$resource'];

    function PlannedShipment ($resource) {
        var resourceUrl =  'api/planned-shipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
